import m from "../../geodata/es2015/peruHigh";
window.am4geodata_peruHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/peruHigh.js
// module id = null
// module chunks = 